import { type FC } from 'react';

import { MainButton } from '@/components/ui/Button/Button';
import { useAppSelector } from '@/redux/store';

import {
  useCardsGameButtonLogic,
  useClaimBoxRewardButtonLogic,
  useMainGameButtonLogic,
} from '../hooks/button-logic';
import { SkipAnimationToggle } from '../SkipAnimationToggle/SkipAnimationToggle';

import { BuyRollEnergyButton } from './BuyRollButton';

const MainDiceGameButton: FC = () => {
  const activeBoard = useAppSelector((state) => state.diceGame.activeBoard);
  const diceCount = useAppSelector((state) => state.diceGame.user?.diceCount);
  const energyCount = useAppSelector((state) => state.diceGame.user?.energy);
  const mainGameProps = useMainGameButtonLogic();
  const cardsProps = useCardsGameButtonLogic();
  const boxRewardProps = useClaimBoxRewardButtonLogic();

  const props =
    activeBoard === 'box'
      ? boxRewardProps
      : activeBoard === 'cards'
        ? cardsProps
        : mainGameProps;

  const showSkipAnimation =
    activeBoard === 'dice' ||
    activeBoard === 'miniGame' ||
    activeBoard === 'cards';

  return (
    <div className="w-full px-10 mt-4 relative z-[2] flex items-center gap-3">
      {showSkipAnimation && <SkipAnimationToggle />}
      <div className="flex-1 min-w-0">
        {activeBoard === 'dice' && (diceCount === 0 || energyCount === 0) ? (
          <BuyRollEnergyButton kind={diceCount === 0 ? 'dice' : 'energy'} />
        ) : (
          <MainButton {...props} />
        )}
      </div>
    </div>
  );
};

export { MainDiceGameButton };
